import { Components, Theme } from '@mui/material';
import type { palette as themePalette } from '~/shared/styles/theme/palette';

export const MuiLink: Components<Theme>['MuiLink'] = {
  styleOverrides: {
    root: ({ theme }) => {
      const palette = theme.palette as unknown as typeof themePalette;
      return {
        color: palette.amount.main,
        '&:hover': {
          color: palette.amount.dark,
        },
      };
    },
  },
};
